import api from './api';

export const deleteAsync = <TResponse = any>(
    url: string,
): Promise<APIResponse<TResponse>> => {
    return api.delete(url);
};
